import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/arconnect.png'


const _withScopeId = n => (_pushScopeId("data-v-9b690994"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " Wallet manager ", -1))
const _hoisted_2 = {
  key: 0,
  class: "accounts-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Login options:", -1))
const _hoisted_5 = { class: "accounts-menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Arweave.app", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ArConnect", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "text-right form-radio"
}
const _hoisted_14 = { class: "" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Wallet Address", -1))
const _hoisted_17 = { class: "address" }
const _hoisted_18 = { class: "address" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Balance", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Network: ", -1))
const _hoisted_21 = { class: "text-center balance" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "AR", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Method", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "accounts-menu" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit Profile", -1))
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Logout", -1))

import { createToast } from 'mosha-vue-toastify';
import { ref, onMounted, watchEffect } from 'vue';
import { UserSettings } from '@/core/UserSettings';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import { ArweaveWrapper, defaultNetwork } from '@/core/ArweaveWrapper';
import ArweaveAddress from '@/components/atomic/ArweaveAddress.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountsManager',
  props: {
	iframe: Boolean,
	tokenState: Object,
	login: Object,
	networkParam: String
},
  setup(__props) {

const props = __props;


const userSettings = new UserSettings();
const settings = userSettings.settings;
const mainAddress = ref('');
const method = ref('');
const chkStayLoggedIn = ref(settings.stayLoggedIn);
/*
const uploadKeyTrigger = () => {
	const txtFile_uploadKey = document.getElementById('txtFile_uploadKey');
	if (txtFile_uploadKey) {
		txtFile_uploadKey.click();
	}
};
*/
const isBridgeActive = ref(false)
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork
const selNetwork = ref(defaultSelNetwork)
const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
const arweave = arweaveWrapper.arweave

/*
const uploadKey = async (event: Event, stayLoggedIn: boolean) => {
	try {
		const address = await props.login.uploadKeyFile(event.target, stayLoggedIn, arweave)
		if (address) {
			mainAddress.value = address
			method.value = props.login.method
		} else {
			throw Error('Error reading wallet address')
		}
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
};
*/

const arConnect = async (stayLoggedIn: boolean) => {
	try {
		let address = '';
		if (props.iframe) {
			address = await props.login.arConnectBridge(stayLoggedIn)
		} else {
			address = await props.login.arConnect(stayLoggedIn, arweave)
		}
		if (address) {
			mainAddress.value = address
			method.value = props.login.method
		} else {
			throw Error('Error reading wallet address')
		}
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
};

const arweaveWebWallet = async (stayLoggedIn: boolean) => {
	try {
		const address = await props.login.arweaveWebWallet(stayLoggedIn)
		if (address) {
			mainAddress.value = address
			method.value = props.login.method
		} else {
			throw Error('Error reading wallet address');
		}
		
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
};

const logout = async () => {
	try {
		if (props.iframe) {
			await props.login.logoutBridge()
		} else {
			await props.login.logout()
		}
		mainAddress.value = '';
		method.value = '';
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
};

onMounted(async () => {
	mainAddress.value = props.login.mainAddress
	method.value = props.login.method
	isBridgeActive.value = false;

	// Fix iframe wallet communication
	if (props.iframe) {
		// Start handshake with parent 
		try {
			isBridgeActive.value = await props.login.isBridgeActive();

		} catch (err) {
			createToast(`${err}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			});
		}
	}

});
watchEffect(async () => {
	userSettings.setStayLoggedIn(chkStayLoggedIn.value)
	if (mainAddress.value) {
		balance.value = 0;
		try {
			const walletBalance = await arweave.wallets.getBalance(mainAddress.value)
			if (walletBalance) {
				balance.value = arweave.ar.winstonToAr(walletBalance)
			}
			
		} catch (err) {
			createToast(`${err}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			});
		}
	}
});

function openLink(url) {
	window.open(url, '_blank')
}
const balance = ref('0');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (__props.login)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!mainAddress.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("ul", _hoisted_5, [
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (arweaveWebWallet(chkStayLoggedIn.value)))
                    }, _hoisted_8)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      disabled: __props.iframe && !isBridgeActive.value,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (arConnect(chkStayLoggedIn.value)))
                    }, _hoisted_12, 8, _hoisted_9)
                  ])
                ]),
                (!__props.iframe)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((chkStayLoggedIn).value = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [
                            _vModelCheckbox,
                            chkStayLoggedIn.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createTextVNode(" Stay Logged In ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, [
                  _createVNode(ArweaveAddress, {
                    address: mainAddress.value,
                    isAddress: true,
                    showProfileImage: true,
                    showHandleInAddress: true,
                    showHandleOnly: true,
                    showLinks: false
                  }, null, 8, ["address"])
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(mainAddress.value), 1),
                _hoisted_19,
                _createElementVNode("p", null, [
                  _hoisted_20,
                  _createElementVNode("span", {
                    class: _normalizeClass({ mainnet: _unref(arweaveWrapper).onMainnet(), other: !_unref(arweaveWrapper).onMainnet()})
                  }, _toDisplayString(selNetwork.value), 3)
                ]),
                _createElementVNode("p", _hoisted_21, [
                  _createTextVNode(_toDisplayString(balance.value) + " ", 1),
                  _hoisted_22
                ]),
                _hoisted_23,
                _createElementVNode("p", null, _toDisplayString(method.value), 1),
                _hoisted_24,
                _createElementVNode("ul", _hoisted_25, [
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (openLink('https://arprofile.org')))
                    }, [
                      _createVNode(_unref(DefaultIcon), {
                        class: "icon-btn",
                        icon: "codicon-account"
                      }),
                      _hoisted_27
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (logout()))
                    }, [
                      _createVNode(_unref(DefaultIcon), {
                        class: "icon-btn",
                        icon: "codicon-sign-out"
                      }),
                      _hoisted_29
                    ])
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})